import { Typography } from "@mui/material";
import { CssTextField } from "./CommonStyles";

const DeliveryTextField = ({
  value,
  onChange,
  disabled,
  placeholder,
  validation,
  setValidation,
  setValueChild,
  required = false,
}) => (
  <>
    <CssTextField
      type="text"
      fullWidth
      value={value || ""}
      inputProps={{
        style: {
          color: "black",
          fontWeight: "normal",
          fontSize: "12px",
        },
      }}
      disabled={disabled}
      onChange={(e) => {
        if (setValidation) setValidation({ msg: "", invalid: false });
        onChange(e.target.value);
        if (setValueChild) setValueChild(e.target.value);
      }}
      variant="standard"
      placeholder={placeholder + (required ? "*" : "")}
    />
    {validation?.invalid && (
      <Typography style={{ color: "red" }} variant="subtitle2">
        {validation.msg}
      </Typography>
    )}
  </>
);

export default DeliveryTextField;
